<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">
    <div class="modal-header">
        <h3 class="modal-title font">Detalle de la respuesta</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body" style="overflow-y: auto;">

        <form [formGroup]="datosForm" class="cont-tab">
            <div class="row-fields">
                <div class="field field-33">
                    <label for="tipo">Fecha </label>
                    <mat-form-field appearance="outline">
                        <input formControlName="fechaAlta" id="fechaAlta" matInput type="text"  placeholder="" >
                    </mat-form-field>
                </div>
                <div class="field field-33">
                    <label for="tipo">Estado </label>
                    <mat-form-field appearance="outline">
                        <input formControlName="estado" id="estado" matInput type="text" placeholder="" >
                    </mat-form-field>
                </div>
                <div class="field field-33" >
                    <div *ngIf="displayUsuario">
                        <label for="tipo">Usuario </label>
                        <mat-form-field appearance="outline">
                            <input formControlName="creadoPor" id="creadoPor" matInput type="text" placeholder="" >
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row-fields">
                <div class="field field-100">
                    <label for="descripcion">Comentarios</label>
                    <mat-form-field appearance="outline" class="textarea-field">
                        <textarea class="form-control" matInput formControlName="comentarios" id="comentarios" rows="5" ></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="row-fields">
                <div class="field field-33">
                    <label for="documento">Documento</label>
                    <div fxLayout="row" fxLayoutAlign="space-between center"
                        *ngIf="(this.comunicacion?.documento != undefined)" class="centrar archivo">
                        <div>
                            <span class="sprite-icon ico-adjuntar"></span><span
                                class="nombre-archivo">{{this.comunicacion.documento!.nombre}}
                            </span>
                            <mat-icon (click)="descargar(this.comunicacion.documento)" class="ml-2 color-custom pointer-cursor"
                                matTooltip="Descargar"> download
                            </mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer actions">
        <div class="button-group">
            <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
                aria-label="Cancelar">Volver</button>
        </div>
    </div>
</div>

